export default __webpack_public_path__ + "static/media/hht1_ep19_timeline_q05_b.104af83d.png";